/**
 * DataBest — role-aware root redirect.
 * Used at "/" and catch-all so users land on their role's operational page.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import useAuthStore from "@/store/authStore";
import { landingPathForRole } from "@/lib/landing";

const RoleLandingRedirect = () => {
    const user = useAuthStore((s) => s.user);
    const accessToken = useAuthStore((s) => s.accessToken);
    if (!accessToken || !user) {
        return <Navigate to="/login" replace />;
    }
    return <Navigate to={landingPathForRole(user.role)} replace />;
};

export default RoleLandingRedirect;
